import { render, staticRenderFns } from "./earningsTrend.vue?vue&type=template&id=36a0b412&scoped=true&"
import script from "./earningsTrend.vue?vue&type=script&lang=js&"
export * from "./earningsTrend.vue?vue&type=script&lang=js&"
import style0 from "./earningsTrend.vue?vue&type=style&index=0&id=36a0b412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a0b412",
  null
  
)

export default component.exports